"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _IconButton = require("../../elements/button/IconButton");
var _cachedBasket = require("../../utils/basket/cachedBasket");
var _brands = require("../../utils/brands/brands");
var _useEmailConfirmed = require("../../utils/hooks/useEmailConfirmed");
var _useWindowSize2 = require("../../utils/hooks/useWindowSize");
var _getProductUrl = _interopRequireDefault(require("../../utils/product/getProductUrl"));
var _EnergyRating = require("../energy-rating/EnergyRating");
var _VisibleOutlined = require("../icons/VisibleOutlined");
var _Price = _interopRequireDefault(require("../price/Price"));
var _SocialProofMessage = require("../social-proof-message/SocialProofMessage");
var _AgeVerification = require("./age-verification/AgeVerification");
var _CtaButton = require("./cta-button/CtaButton");
var _Image = _interopRequireDefault(require("./image/Image"));
var _carousel = require("./image-carousel/carousel");
var carouselStyles = _interopRequireWildcard(require("./image-carousel/product-card-image-carousel.module.scss"));
var _OutOfStock = _interopRequireDefault(require("./out-of-stock/OutOfStock"));
var _PreOrder = _interopRequireDefault(require("./pre-order/PreOrder"));
var styles = _interopRequireWildcard(require("./product-card.module.scss"));
var _PromoMessages = _interopRequireDefault(require("./promo-messages/PromoMessages"));
var _QuickViewDrawer = require("./quick-view-drawer/QuickViewDrawer");
var _shouldShowQuickViewButton = require("./quick-view-drawer/shouldShowQuickViewButton");
var _ProductCardRating = _interopRequireDefault(require("./rating/ProductCardRating"));
var _Sponsored = _interopRequireDefault(require("./sponsored/Sponsored"));
var _Swatches = _interopRequireDefault(require("./swatches/Swatches"));
var _Title = _interopRequireDefault(require("./title/Title"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var defaultCustomerNotifiableEvents = {
  backInStock: false,
  onRelease: false,
  onPreorderLaunch: false,
  newlyInStock: false
};
var ProductCard = function ProductCard(_ref) {
  var _availability$futureA, _availability$preOrde, _energy$rating, _energy$rating2, _energy$rating3, _energy$rating4, _availability$futureA2, _availability$preOrde2;
  var product = _ref.product,
    _ref$buttonSettings = _ref.buttonSettings,
    buttonSettings = _ref$buttonSettings === void 0 ? {} : _ref$buttonSettings,
    _ref$hasAltImageOnHov = _ref.hasAltImageOnHover,
    hasAltImageOnHover = _ref$hasAltImageOnHov === void 0 ? false : _ref$hasAltImageOnHov,
    _ref$hasBrandedTitle = _ref.hasBrandedTitle,
    hasBrandedTitle = _ref$hasBrandedTitle === void 0 ? false : _ref$hasBrandedTitle,
    _ref$hasEnergySideDra = _ref.hasEnergySideDrawer,
    hasEnergySideDrawer = _ref$hasEnergySideDra === void 0 ? false : _ref$hasEnergySideDra,
    _ref$hasImageCarousel = _ref.hasImageCarousel,
    hasImageCarousel = _ref$hasImageCarousel === void 0 ? false : _ref$hasImageCarousel,
    _ref$hasMobileImageCa = _ref.hasMobileImageCarousel,
    hasMobileImageCarousel = _ref$hasMobileImageCa === void 0 ? false : _ref$hasMobileImageCa,
    _ref$hasCarouselPipIn = _ref.hasCarouselPipIndicators,
    hasCarouselPipIndicators = _ref$hasCarouselPipIn === void 0 ? false : _ref$hasCarouselPipIn,
    _ref$hasCarouselAltSt = _ref.hasCarouselAltStart,
    hasCarouselAltStart = _ref$hasCarouselAltSt === void 0 ? false : _ref$hasCarouselAltSt,
    _ref$hasAgeVerificati = _ref.hasAgeVerification,
    hasAgeVerification = _ref$hasAgeVerificati === void 0 ? false : _ref$hasAgeVerificati,
    _ref$hasProductRating = _ref.hasProductRating,
    hasProductRating = _ref$hasProductRating === void 0 ? true : _ref$hasProductRating,
    _ref$hasPromoMessageM = _ref.hasPromoMessageModal,
    hasPromoMessageModal = _ref$hasPromoMessageM === void 0 ? false : _ref$hasPromoMessageM,
    _ref$hasShortCtaText = _ref.hasShortCtaText,
    hasShortCtaText = _ref$hasShortCtaText === void 0 ? false : _ref$hasShortCtaText,
    _ref$hasShortlistView = _ref.hasShortlistView,
    hasShortlistView = _ref$hasShortlistView === void 0 ? false : _ref$hasShortlistView,
    _ref$isFirstProductCa = _ref.isFirstProductCard,
    isFirstProductCard = _ref$isFirstProductCa === void 0 ? false : _ref$isFirstProductCa,
    _ref$isPromoQuickView = _ref.isPromoQuickViewFlagOn,
    isPromoQuickViewFlagOn = _ref$isPromoQuickView === void 0 ? false : _ref$isPromoQuickView,
    _ref$isQuickViewIcon = _ref.isQuickViewIcon,
    isQuickViewIcon = _ref$isQuickViewIcon === void 0 ? false : _ref$isQuickViewIcon,
    _ref$quickViewBundleL = _ref.quickViewBundleLoading,
    quickViewBundleLoading = _ref$quickViewBundleL === void 0 ? false : _ref$quickViewBundleL,
    _ref$hasDiorPromosEna = _ref.hasDiorPromosEnabled,
    hasDiorPromosEnabled = _ref$hasDiorPromosEna === void 0 ? false : _ref$hasDiorPromosEna,
    _ref$hasWishlistPlace = _ref.hasWishlistPlaceholder,
    hasWishlistPlaceholder = _ref$hasWishlistPlace === void 0 ? false : _ref$hasWishlistPlace,
    _ref$hasSwatchTextBut = _ref.hasSwatchTextButNoRoundels,
    hasSwatchTextButNoRoundels = _ref$hasSwatchTextBut === void 0 ? false : _ref$hasSwatchTextBut,
    _ref$atbProps = _ref.atbProps,
    atbProps = _ref$atbProps === void 0 ? {} : _ref$atbProps,
    children = _ref.children,
    className = _ref.className,
    extraChildren = _ref.extraChildren,
    _ref$imageSettings = _ref.imageSettings,
    imageSettings = _ref$imageSettings === void 0 ? {} : _ref$imageSettings,
    moreInformationCustomLabel = _ref.moreInformationCustomLabel,
    _ref$pricePrefix = _ref.pricePrefix,
    pricePrefix = _ref$pricePrefix === void 0 ? '' : _ref$pricePrefix,
    _ref$selectedSwatch = _ref.selectedSwatch,
    selectedSwatch = _ref$selectedSwatch === void 0 ? {} : _ref$selectedSwatch,
    _ref$sponsoredTitleEn = _ref.sponsoredTitleEnabled,
    sponsoredTitleEnabled = _ref$sponsoredTitleEn === void 0 ? false : _ref$sponsoredTitleEn,
    titleHeaderTagLevel = _ref.titleHeaderTagLevel,
    _ref$socialProofMessa = _ref.socialProofMessage,
    socialProofMessage = _ref$socialProofMessa === void 0 ? null : _ref$socialProofMessa,
    _ref$socialProofMessa2 = _ref.socialProofMessageExperiments,
    socialProofMessageExperiments = _ref$socialProofMessa2 === void 0 ? [] : _ref$socialProofMessa2,
    _ref$monetateId = _ref.monetateId,
    monetateId = _ref$monetateId === void 0 ? '' : _ref$monetateId,
    handleClick = _ref.handleClick,
    handleDisplayPromoModal = _ref.handleDisplayPromoModal,
    handleEnergyRatingClick = _ref.handleEnergyRatingClick,
    handleQuickAddClick = _ref.handleQuickAddClick,
    handleQuickViewClick = _ref.handleQuickViewClick,
    handleMoreInformationClick = _ref.handleMoreInformationClick,
    handleSwatchClickProp = _ref.handleSwatchClick,
    _ref$handleMoreSwatch = _ref.handleMoreSwatchesClick,
    handleMoreSwatchesClick = _ref$handleMoreSwatch === void 0 ? undefined : _ref$handleMoreSwatch;
  var adId = product.adId,
    _product$alternativeI = product.alternativeImageUrls,
    alternativeImageUrls = _product$alternativeI === void 0 ? [] : _product$alternativeI,
    availability = product.availability,
    brand = product.brand,
    colorSwatches = product.colorSwatches,
    _product$customerNoti = product.customerNotifiableEvents,
    _product$customerNoti2 = _product$customerNoti === void 0 ? defaultCustomerNotifiableEvents : _product$customerNoti,
    backInStock = _product$customerNoti2.backInStock,
    onRelease = _product$customerNoti2.onRelease,
    onPreorderLaunch = _product$customerNoti2.onPreorderLaunch,
    newlyInStock = _product$customerNoti2.newlyInStock,
    defaultSkuId = product.defaultSkuId,
    energy = product.energy,
    id = product.id,
    image = product.image,
    isMultiSku = product.isMultiSku,
    outOfStock = product.outOfStock,
    price = product.price,
    creditMessage = product.creditMessage,
    _product$promoMessage = product.promoMessages,
    promoMessages = _product$promoMessage === void 0 ? [] : _product$promoMessage,
    rating = product.rating,
    title = product.title,
    url = product.url;
  var isPreorderBackInStock = Boolean(backInStock && outOfStock);
  var isPreOrderable = Boolean((availability === null || availability === void 0 || (_availability$futureA = availability.futureAvailability) === null || _availability$futureA === void 0 ? void 0 : _availability$futureA.availableToOrderFromMessage) || (availability === null || availability === void 0 || (_availability$preOrde = availability.preOrder) === null || _availability$preOrde === void 0 ? void 0 : _availability$preOrde.streetDateMessage));
  var isFutureRelease = Boolean(isPreorderBackInStock || onRelease || onPreorderLaunch || newlyInStock || isPreOrderable);
  var hasEmailMeWhenAvailableButton = buttonSettings.hasEmailMeWhenAvailableButton,
    _buttonSettings$hasQu = buttonSettings.hasQuickViewButton,
    hasQuickViewButton = _buttonSettings$hasQu === void 0 ? true : _buttonSettings$hasQu,
    _buttonSettings$hasCt = buttonSettings.hasCtaButton,
    hasCtaButton = _buttonSettings$hasCt === void 0 ? true : _buttonSettings$hasCt;
  var emailConfirmed = (0, _useEmailConfirmed.useEmailConfirmed)(hasEmailMeWhenAvailableButton, id);
  var _useWindowSize = (0, _useWindowSize2.useWindowSize)(),
    isMobileSize = _useWindowSize.isMobileSize,
    isTabletSizeOrSmaller = _useWindowSize.isTabletSizeOrSmaller;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    swatchOverride = _useState2[0],
    setSwatchOverride = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isQvIconLoading = _useState4[0],
    setIsQvIconLoading = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isQvDrawerForcedClosed = _useState6[0],
    setIsQvDrawerForcedClosed = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    imageHeight = _useState8[0],
    setImageHeight = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState0 = _slicedToArray(_useState9, 2),
    imageWidth = _useState0[0],
    setImageWidth = _useState0[1];

  // PLP-277 temporary carousel state. Can be removed or replaced when /product-card/image-carousel is retired.
  var initialSlideNumber = hasCarouselAltStart ? 1 : 0;
  var _useState1 = (0, _react.useState)(initialSlideNumber),
    _useState10 = _slicedToArray(_useState1, 2),
    currentCarouselSlide = _useState10[0],
    setCurrentCarouselSlide = _useState10[1];
  var _useState11 = (0, _react.useState)(hasImageCarousel || hasMobileImageCarousel),
    _useState12 = _slicedToArray(_useState11, 2),
    showCarousel = _useState12[0],
    setShowCarousel = _useState12[1];
  var cachedBasket = (0, _cachedBasket.useCachedBasketData)();
  var isAddedToBasket = cachedBasket.products.some(function (p) {
    return p.productId === id;
  });
  var isAnyday = (0, _brands.isAnydayBrand)(brand);
  var productCardElement = (0, _react.useRef)();
  var productUrl = swatchOverride ? (0, _getProductUrl.default)(title, id, swatchOverride, adId) : url || (0, _getProductUrl.default)(title, id, selectedSwatch, adId);
  var hasQuickViewIconButton = (0, _shouldShowQuickViewButton.shouldShowQuickViewButton)(product) && isQuickViewIcon;
  var updateImageSize = (0, _react.useCallback)(function () {
    var _productCardElement$c;
    var elementWidth = (_productCardElement$c = productCardElement.current) === null || _productCardElement$c === void 0 ? void 0 : _productCardElement$c.offsetWidth;
    setImageWidth(elementWidth);
    setImageHeight(elementWidth / 0.75);
  }, [productCardElement, setImageHeight, setImageWidth]);
  (0, _react.useEffect)(function () {
    updateImageSize();
  }, [isTabletSizeOrSmaller]);
  var getOverrideSwatch = function getOverrideSwatch(e) {
    var override = colorSwatches.find(function (_ref2) {
      var color = _ref2.color;
      return color === e.currentTarget.title || "".concat(color, " - Out of stock") === e.currentTarget.title;
    });
    return override;
  };
  var handleSwatchClick = function handleSwatchClick(e, index) {
    handleSelectedSwatchClick(e);
    if (handleSwatchClickProp) {
      handleSwatchClickProp(e);
    }
    if (!isTabletSizeOrSmaller && hasImageCarousel || isTabletSizeOrSmaller && hasMobileImageCarousel) {
      if (index > 0) {
        setCurrentCarouselSlide(0);
      } else {
        setSwatchOverride(null);
      }
    }
  };
  var handleSelectedSwatchClick = function handleSelectedSwatchClick(e) {
    e.preventDefault();
    var override = getOverrideSwatch(e);
    if (override) {
      setSwatchOverride(override);
    }
  };
  var handleEnergyArrowClick = function handleEnergyArrowClick(altText, rating) {
    handleEnergyRatingClick(altText, rating, energy.label, energy.informationSheet, adId, id);
  };
  var handleQuickViewIconClick = function handleQuickViewIconClick(_ref3) {
    var _ref3$shouldScrollToP = _ref3.shouldScrollToPromoMsgs,
      shouldScrollToPromoMsgs = _ref3$shouldScrollToP === void 0 ? false : _ref3$shouldScrollToP;
    setIsQvIconLoading(true);
    var swatchOrder = (colorSwatches || []).map(function (_ref4) {
      var color = _ref4.color;
      return color;
    });
    return Promise.resolve(handleQuickViewClick(id, selectedSwatch.url || (0, _getProductUrl.default)(title, id, selectedSwatch), swatchOrder, swatchOverride === null || swatchOverride === void 0 ? void 0 : swatchOverride.color, adId, shouldScrollToPromoMsgs, 'QUICK_VIEW_ICON')).then(function () {
      setIsQvIconLoading(false);
    });
  };
  var handlePromoMessagesClick = function handlePromoMessagesClick(_ref5) {
    var _ref5$shouldScrollToP = _ref5.shouldScrollToPromoMsgs,
      shouldScrollToPromoMsgs = _ref5$shouldScrollToP === void 0 ? false : _ref5$shouldScrollToP;
    setIsQvIconLoading(true);
    var swatchOrder = (colorSwatches || []).map(function (_ref6) {
      var color = _ref6.color;
      return color;
    });
    return Promise.resolve(handleQuickViewClick(id, selectedSwatch.url || (0, _getProductUrl.default)(title, id, selectedSwatch), swatchOrder, swatchOverride === null || swatchOverride === void 0 ? void 0 : swatchOverride.color, adId, shouldScrollToPromoMsgs, 'VIEW_OFFERS')).then(function () {
      setIsQvIconLoading(false);
    });
  };
  var openQuickAdd = function openQuickAdd(_ref7) {
    var _ref7$shouldShowOffer = _ref7.shouldShowOffersView,
      shouldShowOffersView = _ref7$shouldShowOffer === void 0 ? false : _ref7$shouldShowOffer;
    var swatchOrder = (colorSwatches || []).map(function (_ref8) {
      var color = _ref8.color;
      return color;
    });
    return Promise.resolve(handleQuickAddClick(id, productUrl, swatchOrder, swatchOverride === null || swatchOverride === void 0 ? void 0 : swatchOverride.color, adId, shouldShowOffersView));
  };
  (0, _react.useEffect)(function () {
    updateImageSize();
    window.addEventListener('resize', updateImageSize);
    return function () {
      window.removeEventListener('resize', updateImageSize);
    };
  }, [updateImageSize]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("article", {
    ref: productCardElement,
    className: (0, _classnames.default)(styles['c-product-card'], className, carouselStyles['c-product-card']),
    "data-jlds": true,
    "data-product-id": id,
    "data-testid": "product-card",
    id: id,
    children: [socialProofMessage && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SocialProofMessage.SocialProofMessage, {
      message: socialProofMessage,
      monetateId: monetateId,
      socialProofMessageExperiments: socialProofMessageExperiments
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _classnames.default)(styles['c-product-card__image-container'], _defineProperty({}, styles['c-product-card__image-container--hasCarousel'], showCarousel)),
      "data-testid": "product-image-container",
      children: [showCarousel ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_carousel.Carousel, {
        carouselStyles: carouselStyles,
        handleClick: handleClick,
        hasPipIndicators: hasCarouselPipIndicators,
        hasSwipePreviewAnimation: isFirstProductCard,
        imageSettings: imageSettings,
        images: [image].concat(_toConsumableArray(alternativeImageUrls)),
        multipleSwatches: colorSwatches && colorSwatches.length > 1,
        selectedSwatch: swatchOverride,
        setCurrentSlide: setCurrentCarouselSlide,
        setShowCarousel: setShowCarousel,
        title: title,
        url: productUrl,
        width: imageWidth
      }, id) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.default, _objectSpread({
        alternativeImageUrls: alternativeImageUrls,
        className: (0, _classnames.default)(styles['c-product-card__image'], 'product__image'),
        handleClick: handleClick,
        hasAltImageOnHover: hasAltImageOnHover,
        image: image,
        multipleSwatches: colorSwatches && colorSwatches.length > 1,
        selectedSwatch: swatchOverride || selectedSwatch,
        title: title,
        url: productUrl
      }, imageSettings)), (hasWishlistPlaceholder || hasQuickViewIconButton) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['c-cta-buttons__right'],
        children: [hasWishlistPlaceholder && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['c-cta-buttons--add-to-wishlist'],
          "data-product-id": id,
          "data-product-multi-sku": isMultiSku ? 'true' : 'false',
          "data-product-skuid": defaultSkuId,
          "data-wishlist-placeholder": true
        }), hasQuickViewIconButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.IconButton, {
          IconComponent: _VisibleOutlined.VisibleOutlined,
          ariaLabel: "Quick view for ".concat(title),
          className: styles['c-cta-buttons--quick-view'],
          "data-testid": "icon-quick-view-button",
          onClick: handleQuickViewIconClick,
          size: "small",
          submitting: isQvIconLoading || quickViewBundleLoading,
          title: "Quick view"
        })]
      }), hasQuickViewButton && !isAddedToBasket && !isQuickViewIcon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_QuickViewDrawer.QuickViewDrawer, {
        className: (0, _classnames.default)(styles['c-product-card__hover-drawer'], _defineProperty({}, styles['c-product-card__hover-drawer__force-close'], isQvDrawerForcedClosed)),
        onClick: handleQuickViewClick,
        product: product,
        quickViewBundleLoading: quickViewBundleLoading,
        selectedSwatch: selectedSwatch,
        swatchOrder: (colorSwatches || []).map(function (_ref9) {
          var color = _ref9.color;
          return color;
        }),
        swatchOverride: swatchOverride
      })]
    }), hasCtaButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CtaButton.CtaButton, _objectSpread(_objectSpread({}, buttonSettings), {}, {
      atbProps: atbProps,
      className: styles['c-product-card__cta'],
      emailConfirmed: emailConfirmed,
      handleMoreInformationClick: handleMoreInformationClick,
      handleQuickAddClick: handleQuickAddClick,
      handleQuickViewClick: handleQuickViewClick,
      hasShortCtaText: hasShortCtaText,
      isAddedToBasket: isAddedToBasket,
      moreInformationCustomLabel: moreInformationCustomLabel,
      product: product,
      productUrl: productUrl,
      quickViewBundleLoading: quickViewBundleLoading,
      selectedSwatch: selectedSwatch,
      showViewOptions: hasShortlistView,
      swatchOrder: (colorSwatches || []).map(function (_ref0) {
        var color = _ref0.color;
        return color;
      }),
      swatchOverride: swatchOverride
    })), extraChildren, /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['c-product-card__product-details'],
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
        className: styles['c-product-card__link'],
        href: productUrl,
        onClick: handleClick,
        tabIndex: 0,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: (0, _classnames.default)(styles['c-product-card__title']),
          "data-testid": "product-title",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Title.default, {
            brand: isAnyday ? 'Anyday' : brand,
            brandPrefix: isAnyday ? 'John Lewis ' : '',
            headerTagLevel: titleHeaderTagLevel,
            isAnyday: isAnyday,
            isBranded: brand && hasBrandedTitle,
            selectedSwatch: swatchOverride || selectedSwatch,
            title: title
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Sponsored.default, {
        className: styles['c-product-card__sponsored'],
        hasSponsoredTitle: sponsoredTitleEnabled
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Price.default, {
        brand: brand,
        className: (0, _classnames.default)(styles['c-product-card__section'], _defineProperty(_defineProperty({}, styles['c-product-card__price-credit'], creditMessage), styles['c-product-card__sponsored-price'], sponsoredTitleEnabled)),
        creditMessage: creditMessage,
        dataTestIdPrefix: "product-card",
        hasDiorPromosEnabled: hasDiorPromosEnabled,
        price: price,
        pricePrefix: pricePrefix
      }), hasProductRating && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductCardRating.default, {
        className: styles['c-product-card__section'],
        rating: rating
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_EnergyRating.EnergyRating, {
      className: (0, _classnames.default)(styles['c-product-card__section'], styles.energyRating, _defineProperty({}, styles.legacy, energy === null || energy === void 0 || (_energy$rating = energy.rating) === null || _energy$rating === void 0 ? void 0 : _energy$rating.legacy)),
      handleEnergyRatingClick: handleEnergyArrowClick,
      hasEnergySideDrawer: hasEnergySideDrawer,
      rating: energy !== null && energy !== void 0 && (_energy$rating2 = energy.rating) !== null && _energy$rating2 !== void 0 && _energy$rating2.legacy ? undefined : energy === null || energy === void 0 || (_energy$rating3 = energy.rating) === null || _energy$rating3 === void 0 ? void 0 : _energy$rating3.value,
      ratingLegacy: energy !== null && energy !== void 0 && (_energy$rating4 = energy.rating) !== null && _energy$rating4 !== void 0 && _energy$rating4.legacy ? energy.rating.value : undefined
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Swatches.default, {
      baseUrl: productUrl,
      className: styles['c-product-card__section'],
      handleClick: handleSwatchClick,
      handleMoreSwatchesClick: handleMoreSwatchesClick,
      hasSwatchTextButNoRoundels: hasSwatchTextButNoRoundels,
      id: id,
      imageLoading: imageSettings.loading,
      selectedSwatch: swatchOverride || selectedSwatch,
      setIsQvDrawerForcedClosed: setIsQvDrawerForcedClosed,
      swatches: colorSwatches,
      title: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PromoMessages.default, {
      brand: brand,
      handleDisplayModal: handleDisplayPromoModal,
      handleQuickAddClick: openQuickAdd,
      handleQuickViewClick: handlePromoMessagesClick,
      hasDiorPromosEnabled: hasDiorPromosEnabled,
      hasPromoMessageModal: hasPromoMessageModal,
      hasViewMoreLink: hasShortlistView,
      isMobileSize: isMobileSize,
      isPromoQuickViewFlagOn: isPromoQuickViewFlagOn,
      productUrl: productUrl,
      promos: promoMessages,
      title: title,
      wrapperClassName: styles['c-product-card__section']
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PreOrder.default, {
      availableToOrder: availability === null || availability === void 0 || (_availability$futureA2 = availability.futureAvailability) === null || _availability$futureA2 === void 0 ? void 0 : _availability$futureA2.availableToOrderFromMessage,
      className: styles['c-product-card__section'],
      streetDate: availability === null || availability === void 0 || (_availability$preOrde2 = availability.preOrder) === null || _availability$preOrde2 === void 0 ? void 0 : _availability$preOrde2.streetDateMessage
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_OutOfStock.default, {
      className: (0, _classnames.default)([styles['c-product-card__section']]),
      isFutureRelease: isFutureRelease,
      outOfStock: outOfStock
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AgeVerification.AgeVerification, {
      className: styles['c-product-card__section'],
      hasAgeVerification: hasAgeVerification
    }), _react.Children.map(children, function (child) {
      if (child) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['c-product-card__section'],
          "data-testid": "product-card-child-item",
          children: child
        });
      }
      return null;
    })]
  });
};
ProductCard.displayName = 'ProductCard';
var colorSwatchType = _propTypes.default.shape({
  color: _propTypes.default.string,
  basicColor: _propTypes.default.string,
  colorSwatchUrl: _propTypes.default.string,
  imageUrl: _propTypes.default.string,
  isAvailable: _propTypes.default.bool,
  skuId: _propTypes.default.string,
  id: _propTypes.default.string,
  isColorOfDefaultVariant: _propTypes.default.bool,
  url: _propTypes.default.string
});
ProductCard.propTypes = {
  /** Product data */
  product: _propTypes.default.shape({
    /** Colour variants for product (if you want to show them) */
    colorSwatches: _propTypes.default.arrayOf(colorSwatchType),
    /** Is the product in store only (eg knives) */
    isInStoreOnly: _propTypes.default.bool,
    /** Product ID */
    id: _propTypes.default.string.isRequired,
    /** Main/default product image */
    image: _propTypes.default.string.isRequired,
    /** Is the product out of stock */
    outOfStock: _propTypes.default.bool,
    /** Pricing object: { was, then1, then2, now } each a string or a range { from, to } */
    price: _propTypes.default.shape(_Price.default.propTypes),
    // Product Credit information */
    creditMessage: _propTypes.default.string,
    /** Array of promo messages to display */
    promoMessages: _propTypes.default.arrayOf(_propTypes.default.string),
    /** Rating summary: { averageRating, reviews } */
    rating: _propTypes.default.shape(_ProductCardRating.default.propTypes),
    /** Product title */
    title: _propTypes.default.string.isRequired,
    /** Product (default) URL */
    url: _propTypes.default.string,
    /** Alternative product images */
    alternativeImageUrls: _propTypes.default.arrayOf(_propTypes.default.string),
    /** Default SkuId for the product */
    skuId: _propTypes.default.string,
    /** default variantId for the product */
    variantId: _propTypes.default.string,
    /** Indicates if a product is a future release */
    customerNotifiableEvents: _propTypes.default.shape({
      backInStock: _propTypes.default.bool,
      onRelease: _propTypes.default.bool,
      onPreorderLaunch: _propTypes.default.bool,
      newlyInStock: _propTypes.default.bool
    }),
    /** Indicates if a product is preorderable */
    availability: _propTypes.default.shape({
      futureAvailability: _propTypes.default.shape({
        availableToOrderFromMessage: _propTypes.default.string
      }),
      preOrder: _propTypes.default.shape({
        streetDateMessage: _propTypes.default.string
      })
    }),
    /** Is this a multisku product */
    isMultiSku: _propTypes.default.bool,
    type: _propTypes.default.string,
    isMadeToMeasure: _propTypes.default.bool,
    isFabricByLength: _propTypes.default.bool
  }).isRequired,
  /** Currently displayed variant: { skuId, color, url, colorSwatchUrl, imageUrl, isAvailable } */
  selectedSwatch: colorSwatchType,
  buttonSettings: _propTypes.default.shape({
    /** Enable the quickview button */
    hasQuickViewButton: _propTypes.default.bool,
    /** Enable the email when available button */
    hasEmailMeWhenAvailableButton: _propTypes.default.bool,
    /** Enable the notify me button for future releases */
    hasNotifyMeButton: _propTypes.default.bool,
    /** Enable the add to basket button */
    hasAddToBasketButton: _propTypes.default.bool,
    /** Enable the More Information button for complex products */
    hasMoreInformationButton: _propTypes.default.bool,
    /** Enable Go to your basket button, if the SKU is in found in the cached_basket cookie */
    hasGoToBasketButton: _propTypes.default.bool,
    /** Enable We'll be in touch button */
    hasBeInTouchButton: _propTypes.default.bool,
    /** Enable Out of stock button */
    hasOosButton: _propTypes.default.bool,
    /** Enable More Information button to be displayed as a PrimaryButton */
    isMoreInformationButtonPrimary: _propTypes.default.bool,
    /** The name of the product Brand */
    brand: _propTypes.default.string
  }),
  /** Custom More Information label overwrite */
  moreInformationCustomLabel: _propTypes.default.string,
  /** Custom event handler fired when clicking on any hyperlink within the card */
  handleClick: _propTypes.default.func,
  /** Optional flag to enable Dior changes */
  hasDiorPromosEnabled: _propTypes.default.bool,
  /** Optional flag to use short CTA texts */
  hasShortCtaText: _propTypes.default.bool,
  /** Optional flag to use in shortlist modal view */
  hasShortlistView: _propTypes.default.bool,
  /** Optional property to render Social Proof Message */
  socialProofMessage: _propTypes.default.string,
  /** Monetate environment identifier */
  monetateId: _propTypes.default.string,
  handleQuickAddClick: _propTypes.default.func,
  handleQuickViewClick: _propTypes.default.func,
  /** Section to pass extra child content */
  extraChildren: _propTypes.default.node,
  /** Show additional pricing text */
  pricePrefix: _propTypes.default.string,
  /** Image settings for sizing and loading */
  imageSettings: _propTypes.default.shape({
    /** Set the sizes attribute on the product image */
    sizes: _propTypes.default.string,
    /** Customize the set of widths for the product image srcSet attribute */
    srcSetWidths: _propTypes.default.arrayOf(_propTypes.default.string),
    /** Set a custom aspect ratio for the image */
    aspectRatio: _propTypes.default.number,
    /** The image loading strategy to use */
    loading: _propTypes.default.oneOf(['eager', 'lazy'])
  }),
  /** Add to basket button props */
  atbProps: _propTypes.default.shape({
    path: _propTypes.default.string,
    clientId: _propTypes.default.string.isRequired,
    onSuccess: _propTypes.default.func,
    onError: _propTypes.default.func,
    hasHeaderBasketCountEvent: _propTypes.default.bool,
    hasScreenReaderAnnouncement: _propTypes.default.bool
  }),
  /** Indicates that product card should show Sponsored */
  sponsoredTitleEnabled: _propTypes.default.bool,
  /** Custom event handler fired when clicking on any swatch within the card */
  handleSwatchClick: _propTypes.default.func,
  /** Custom event handler fired when clicking on more colours available link within the card */
  handleMoreSwatchesClick: _propTypes.default.func,
  /** QuickView bundle is being lazy loaded */
  quickViewBundleLoading: _propTypes.default.bool,
  /** Indicate whether to try to display first alt image when main image hovered over */
  hasAltImageOnHover: _propTypes.default.bool,
  /** Displays QV icon */
  isQuickViewIcon: _propTypes.default.bool,
  /** Displays QV when View more offers button pressed */
  isPromoQuickViewFlagOn: _propTypes.default.bool,
  /** Custom event handler fired when displaying promo modal */
  handleDisplayPromoModal: _propTypes.default.func,
  /** Custom event handler fired when More information CTA button has been clicked */
  handleMoreInformationClick: _propTypes.default.func,
  /** Sets <H(1-6)> tag level for the title */
  titleHeaderTagLevel: _propTypes.default.number,
  /** Indicates product card should show age verification message  */
  hasAgeVerification: _propTypes.default.bool,
  /** Indicates whether only total number of swatches should be shown */
  hasSwatchTextButNoRoundels: _propTypes.default.bool
};
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(ProductCard);